/**
 * Import Site 3D layout tables (or the default square grid) into the 2D Site Layout editor.
 */
import * as global from "../data/global.js";
import {
    layoutTablesToEditorGeometry,
    separateTouchingAutoGridMarkers,
} from "./layoutTablesToEditor.js";
import { defaultLayoutFeetPerPixel } from "./siteLayoutStice.js";

/** Ensure selectedSite has layoutBins — runs initializeSiteLayout when API returned none. */
export const ensureSite3dLayoutBins = (site) => {
    if (!site) return false;
    if (site.layoutBins?.length > 0) return true;
    if (!(site.bins?.length > 0)) return false;
    try {
        global.initializeSiteLayout?.();
    } catch (err) {
        console.warn("initializeSiteLayout", err);
    }
    return (site.layoutBins?.length ?? 0) > 0;
};

/**
 * @param {object} site — global.gw.selectedSite
 * @param {object} options — feetPerPixel, imageWidth, imageHeight
 */
export const buildEditorGeometryFromSite3d = (site, options = {}) => {
    if (!ensureSite3dLayoutBins(site)) return null;

    const siteBins = site.bins ?? [];
    const fpp =
        options.feetPerPixel > 0
            ? options.feetPerPixel
            : defaultLayoutFeetPerPixel(siteBins);

    try {
        global.ensureLayoutSideRenderGeometry?.(site);
    } catch (err) {
        console.warn("ensureLayoutSideRenderGeometry", err);
    }

    const imgW = Math.max(options.imageWidth || 2400, 1);
    const imgH = Math.max(options.imageHeight || 1600, 1);

    const geom = layoutTablesToEditorGeometry(site, {
        feetPerPixel: fpp,
        imageWidth: imgW,
        imageHeight: imgH,
    });
    if (!geom) return null;

    // Default Site 3D grid packs bins edge-to-edge; spread them so enclosure does not synthesize gap pockets.
    if (!site.hasPersistedSiteLayout) {
        return separateTouchingAutoGridMarkers(geom, options.binGapFt);
    }
    return geom;
};
